import { NbMenuItem } from '@nebular/theme';

export const MENU_ITEMS: NbMenuItem[] = [
  {
    title: 'MAIN',
    icon: 'home-outline',
    link: '/adelita/dashboard',
    home: true,
    hidden: false,
    target: "group"
  },
  {
    title: 'RENT',
    icon: 'calendar-outline',
    link: '/adelita/operations/sale-or-rent-item/sale-or-rent-item-component',
    hidden: true,
    data: 'rent',
    target: "item"
  },
  {
    title: 'SALE',
    icon: 'shopping-cart-outline',
    link: '/adelita/operations/sale-item/sale-item-component',
    hidden: true,
    data: 'sale',
    target: "item"
  },
  {
    title: 'DRESSAVAILABILITY',
    icon: 'checkmark-square-outline',
    link: '/adelita/reports/availability-dress/availability-dress-component',
    hidden: true,
    data: 'dressAvailability',
    target: "item"
  },
  {
    title: 'OPERATIONS',
    icon: 'options-2-outline',
    hidden: true,
    target: "collapse",
    children: [
      {
        title: 'DELIVERY',
        icon: 'arrow-right-outline',
        link: '/adelita/operations/delivery/delivery-component',
        hidden: true,
        data: 'delivery',
        target: "item"
      },
      {
        title: 'RECEIVE',
        icon: 'arrow-right-outline',
        link: '/adelita/operations/receive/receive-component',
        hidden: true,
        data: 'receive',
        target: "item"
      },
      {
        title: 'CANCELRENT',
        icon: 'arrow-right-outline',
        link: '/adelita/operations/cancel-rent/cancel-rent-component',
        hidden: true,
        data: 'cancelRent',
        target: "item"
      },
      {
        title: 'EDITRENT',
        icon: 'arrow-right-outline',
        link: '/adelita/operations/edit-rent/edit-rent-component',
        hidden: true,
        data: 'editRent',
        target: "item"
      },
      {
        title: 'TICKETREPRINT',
        icon: 'arrow-right-outline',
        link: '/adelita/operations/ticket-reprint/ticket-reprint-component',
        hidden: true,
        data: 'ticketReprint',
        target: "item"
      }
    ]
  },
  {
    title: 'REPORTS',
    icon: 'pie-chart-outline',
    hidden: true,
    target: "collapse",
    children: [
      {
        title: 'PENDINGDELIVERY',
        icon: 'arrow-right-outline',
        link: '/adelita/reports/pending-delivery/pending-delivery-component',
        hidden: true,
        data: 'pendingDelivery',
        target: "item"
      },
      {
        title: 'PENDINGRECEIVE',
        icon: 'arrow-right-outline',
        link: '/adelita/reports/pending-receive/pending-receive-component',
        hidden: true,
        data: 'pendingReceive',
        target: "item"
      },
      {
        title: 'RENTEDDRESSES',
        icon: 'arrow-right-outline',
        link: '/adelita/reports/rented-dresses/rented-dresses-component',
        hidden: true,
        data: 'rentedDresses',
        target: "item"
      },
      {
        title: 'COMMISSIONS',
        icon: 'arrow-right-outline',
        link: '/adelita/reports/commissions/commissions-component',
        hidden: true,
        data: 'commissions',
        target: "item"
      },
      {
        title: 'FINANCIALINCOME',
        icon: 'arrow-right-outline',
        link: '/adelita/reports/financial-income/financial-income-component',
        hidden: true,
        data: 'financialIncome',
        target: "item"
      },
      {
        title: 'DRESS',
        icon: 'arrow-right-outline',
        link: '/adelita/reports/dress/dress-component',
        hidden: true,
        data: 'dress',
        target: "item"
      }
    ]
  },
  {
    title: 'CATALOGS',
    icon: 'settings',
    hidden: true,
    target: "collapse",
    children: [
      {
        title: 'ITEM',
        icon: 'arrow-right-outline',
        link: '/adelita/catalogs/item/item-component',
        hidden: true,
        data: 'item',
        target: "item"
      },
      {
        title: 'BRAND',
        icon: 'arrow-right-outline',
        link: '/adelita/catalogs/brand/brand-component',
        hidden: true,
        data: 'brand',
        target: "item"
      },
      {
        title: 'CATEGORY',
        icon: 'arrow-right-outline',
        link: '/adelita/catalogs/category/category-component',
        hidden: true,
        data: 'category',
        target: "item"
      },
      {
        title: 'DISCOUNT',
        icon: 'arrow-right-outline',
        link: '/adelita/catalogs/discount/discount-component',
        hidden: true,
        data: 'discount',
        target: "item"
      },
      {
        title: 'MODEL',
        icon: 'arrow-right-outline',
        link: '/adelita/catalogs/model/model-component',
        hidden: true,
        data: 'model',
        target: "item"
      },
      {
        title: 'PENALTY',
        icon: 'arrow-right-outline',
        link: '/adelita/catalogs/penalty/penalty-component',
        hidden: true,
        data: 'penalty',
        target: "item"
      },
      {
        title: 'CUSTOMERS',
        icon: 'arrow-right-outline',
        link: '/adelita/catalogs/customer/customer-component',
        hidden: true,
        data: 'customer',
        target: "item"
      }
    ]
  },
  {
    title: 'SECURITY',
    icon: 'unlock-outline',
    hidden: true,
    target: "collapse",
    children: [
      {
        title: 'ROLES',
        icon: 'unlock-outline',
        link: '/adelita/catalogs/access-group/access-group-component',
        hidden: true,
        data: 'rol',
        target: "item"
      },
      {
        title: 'USERS',
        icon: 'person-add-outline',
        link: '/adelita/catalogs/user/user-component',
        hidden: true,
        data: 'user',
        target: "item"
      }
    ]
  },
];
